import { Component } from '@angular/core';

@Component({
  selector: 'app-authentication-container',
  templateUrl: './authentication-container.component.html',
  styleUrls: ['./authentication-container.component.scss'],
})
export class AuthenticationContainerComponent {}
